module.exports = [
	{
		"type": "mountain",
		"name": "lidongo",
		"coordinates": [
			18.1408739,
			59.3503239
		],
		"y": -2,
		"options": {
			"color": "blue"
		}
	},
	{
		"type": "mountain",
		"name": "gardet",
		"coordinates": [
			18.117485,
			59.336341
		],
		"y": -100,
		"options": {
			"color": "purple"
		}
	},
	{
		"type": "mountain",
		"name": "danderyd",
		"coordinates": [
			18.051567,
			59.383059
		],
		"y": 500,
		"options": {
			"color": "purple"
		}
	},
	{
		"type": "mountain",
		"name": "centralLidingo",
		"coordinates": [
			18.118858,
			59.36172
		],
		"y": 300,
		"options": {
			"color": "purple"
		}
	},
	{
		"type": "mountain",
		"name": "hagaparken",
		"coordinates": [
			18.01792,
			59.35629
		],
		"y": 600,
		"options": {
			"color": "blue"
		}
	},
	{
		"type": "mountain",
		"name": "friends",
		"coordinates": [
			18.00006,
			59.37274
		],
		"y": 600,
		"options": {
			"color": "pink"
		}
	},
	{
		"type": "mountain",
		"name": "essinge",
		"coordinates": [
			17.99182,
			59.32145
		],
		"y": 600,
		"options": {
			"color": "blue"
		}
	},
	{
		"type": "mountain",
		"name": "bromma",
		"coordinates": [
			17.96281,
			59.32951
		],
		"y": 500,
		"options": {
			"color": "purple"
		}
	},
	{
		"type": "mountain",
		"name": "liljeholmen",
		"coordinates": [
			18.01577,
			59.31195
		],
		"y": 500,
		"options": {
			"color": "pink"
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/json/objects.json
// module id = 18
// module chunks = 0